export enum FieldType {
  static = 'static',
  reference = 'reference',
  computed = 'computed',
  custom = 'custom'
}
